import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4ed69e25")
const _hoisted_1 = {
  key: 1,
  class: "p-grid tutorAssigment-groups"
}
const _hoisted_2 = { class: "p-col-7 p-fluid p-mt-2" }
const _hoisted_3 = { class: "p-field p-d-flex p-ai-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "tutors",
  class: "p-text-bold text-size-16 p-mb-0 p-mr-3"
}, "Tutor: ", -1)
const _hoisted_5 = { class: "p-d-flex p-jc-between" }
const _hoisted_6 = { class: "p-d-flex" }
const _hoisted_7 = {
  key: 0,
  class: "p-d-flex p-jc-center"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-pencil",
  style: {"color":"#5140AA"},
  clickable: ""
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-trash",
  style: {"color":"#5140AA"},
  clickable: ""
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "p-d-flex p-jc-center"
}
const _hoisted_15 = {
  key: 0,
  class: "p-col-4 p-offset-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "p-text-bold text-size-16" }, "PowerBi", -1)
const _hoisted_17 = { class: "p-field p-fluid" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "powerBiAccount",
  class: "p-d-block"
}, "Cuenta Docente", -1)
const _hoisted_19 = { class: "p-field p-fluid" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "powerBiPass",
  class: "p-d-block"
}, "Clave Docente", -1)
const _hoisted_21 = {
  key: 0,
  class: "p-d-none"
}
const _hoisted_22 = { class: "p-field p-fluid" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "editingAliasGroup",
  class: "p-d-block"
}, "Ingrese alias", -1)
const _hoisted_24 = { class: "p-field p-fluid" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "editingAccountUserGroup",
  class: "p-d-block"
}, "Ingrese cuenta de docente", -1)
const _hoisted_26 = { class: "p-field p-fluid" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "editingAccountPassGroup",
  class: "p-d-block"
}, "Ingrese clave de docente", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CoderBadge = _resolveComponent("CoderBadge")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.tutors)
      ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Dropdown, {
                id: "tutors",
                class: "p-mr-3",
                modelValue: _ctx.selectedTutor,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedTutor = $event)),
                options: Array.from(_ctx.tutors.values()),
                optionLabel: "fullName",
                optionValue: "id",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeTutor()))
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  label: "Crear grupo",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onNewGroups()))
                })
              ])
            ]),
            _createElementVNode("div", null, [
              (_ctx.selectedTutor)
                ? (_openBlock(), _createBlock(_component_DataTable, {
                    key: 0,
                    class: "p-datatable-groups",
                    showGridlines: "",
                    responsiveLayout: "scroll",
                    value: _ctx.students.get(_ctx.selectedTutor)
                  }, _createSlots({
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "profile.name",
                        header: "Estudiantes"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", null, _toDisplayString(data.profile?.name) + " " + _toDisplayString(data.profile?.lastName), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups.keys(), (col) => {
                        return (_openBlock(), _createBlock(_component_Column, {
                          field: col,
                          header: col,
                          key: col
                        }, {
                          body: _withCtx(({data, column}) => [
                            (!data?.user?.personId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.editGroup(column)),
                                    style: {"margin":"3px"},
                                    title: "Editar grupo",
                                    clickable: ""
                                  }, _hoisted_10, 8, _hoisted_8),
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.deleteGroup(column)),
                                    style: {"margin":"3px"},
                                    title: "Eliminar grupo",
                                    clickable: ""
                                  }, _hoisted_13, 8, _hoisted_11)
                                ]))
                              : _createCommentVNode("", true),
                            (data?.user?.personId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_component_Checkbox, {
                                    id: data.user.personId,
                                    value: data.user.personId,
                                    modelValue: _ctx.checkboxControl.get(column.key)[data.user.personId],
                                    "onUpdate:modelValue": ($event: any) => (_ctx.checkboxControl.get(column.key)[data.user.personId] = $event),
                                    binary: true,
                                    onChange: ($event: any) => (_ctx.changeValueGroup(data?.user?.personId, column.key))
                                  }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "onChange"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["field", "header"]))
                      }), 128))
                    ]),
                    _: 2
                  }, [
                    (_ctx.checkboxControl)
                      ? {
                          name: "header",
                          fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_router_link, {
                                class: "person-name",
                                to: {
                  name: _ctx.EducationRouteNames.PERSON_PROFILE_GENERAL,
                  params: { personId: _ctx.selectedTutor }
                }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.tutors.get(_ctx.selectedTutor).fullName), 1)
                                ]),
                                _: 1
                              }, 8, ["to"]),
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_CoderBadge, {
                                  text: `${Array.from(_ctx.checkboxControl.values()).length} Grupos`,
                                  backgroundColor: '#DDDDDD',
                                  fontSize: '12px'
                                }, null, 8, ["text"])
                              ])
                            ])
                          ])
                        }
                      : undefined
                  ]), 1032, ["value"]))
                : _createCommentVNode("", true)
            ])
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_InputText, {
                    id: "powerBiAccount",
                    type: "email",
                    placeholder: "Cuenta Docente",
                    modelValue: _ctx.teachersPowerBiRef.teachersPowerBiAccount,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.teachersPowerBiRef.teachersPowerBiAccount = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_InputText, {
                    id: "powerBiPass",
                    type: "text",
                    placeholder: "Clave Docente",
                    modelValue: _ctx.teachersPowerBiRef.teachersPowerBiPass,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.teachersPowerBiRef.teachersPowerBiPass = $event))
                  }, null, 8, ["modelValue"])
                ]),
                (!_ctx.disabledButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_Button, {
                        label: "Cancelar",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetPowerBi())),
                        class: "p-button-outlined p-mr-3 p-mb-3"
                      }),
                      _createVNode(_component_Button, {
                        label: "Guardar",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.savePowerBi())),
                        class: "p-mb-3"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_Dialog, {
      visible: _ctx.displayNewGroup,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (_ctx.displayNewGroup = $event)),
      header: _ctx.dialogText.title
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancelar",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeModalGroup()))
        }),
        _createVNode(_component_Button, {
          label: "Confirmar",
          icon: "pi pi-check",
          autofocus: "",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.confirmModalGroup()))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_InputText, {
            id: "editingAliasGroup",
            modelValue: _ctx.editingAliasGroup,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.editingAliasGroup = $event)),
            placeholder: "Ingrese alias"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_InputText, {
            id: "editingAccountUserGroup",
            modelValue: _ctx.editingAccountUserGroup,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.editingAccountUserGroup = $event)),
            placeholder: "Ingrese cuenta de docente"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode(_component_InputText, {
            id: "editingAccountPassGroup",
            modelValue: _ctx.editingAccountPassGroup,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.editingAccountPassGroup = $event)),
            placeholder: "Ingrese clave de docente"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}